import $ from 'jquery';
import 'slick-carousel';

const sliders = [
	{
		class: '.em-video-slider__slider',
		args: {
			arrows: true,
			fade: true,
			slidesToShow: 1,
			dots: true,
		},
	},
];

class VideoSlider {
	constructor(slider, customArgs) {
		this.slider = $(slider);
		this.args = {};

		if (Object.values(customArgs).length) {
			this.args = customArgs;
		}
	}

	load() {
		if (this.slider.length) {
			this.slider.slick(this.args);
		}
	}
}

const videoSlider = {
	sliderArgs: sliders,
	class: '',
	args: [],
	imageUrl: '',
	loadSlider() {
		const videoSlider = new VideoSlider(this.class, this.args);
		videoSlider.load();
	},
	preloadImage() {
		const url = this.imageUrl;
		const img = new Image();
		img.src = url;
		img.classList.add('loaded');
		img.setAttribute('data-ll-status', 'loaded');
		img.setAttribute('alt', '');
		return img;
	},
	init() {
		sliders.forEach((slider) => {
			// Load Youtube Thumbnail Images first before loading Slick Slider.
			const sliderContainers = [...document.querySelectorAll(slider.class)];
			if (sliderContainers.length) {
				sliderContainers.forEach((sliderContainer) => {
					const sliderChildren = sliderContainer.children.length ? Object.values(sliderContainer.children) : [];
					sliderChildren.forEach((childSlide) => {
						const hasWordPressThumbnail = childSlide.dataset.hasThumbnail;

						if (hasWordPressThumbnail === 'false') {
							const { imageUrl } = childSlide.dataset;
							this.imageUrl = imageUrl;
							const newImage = this.preloadImage();
							childSlide.prepend(newImage);
						}
					});
				});
			}

			// Load in Slick Slider.
			this.class = slider.class;
			this.args = slider.args;
			this.loadSlider();
		});
	},
};

videoSlider.init();

export default videoSlider;
